import type { Editor } from '@tiptap/react';
import { BubbleMenu } from '@tiptap/react';
import React from 'react';
import { useSplitTreatment } from '../../../split-treatment';
import { BlueprintTextEditorToolbar } from './blueprint-text-editor-toolbar/blueprint-text-editor-toolbar';
import { BuieTextEditorToolbar } from './buie-text-editor-toolbar/buie-text-editor-toolbar';
import { FEATURE_FLAGS } from '../../../../constants/feature-flags';

type TextEditorToolbarProps = {
  editor: Editor;
};

/*
 * VariantComponent memorizes the component to avoid unnecessary re-renders (FORMS-5944).
 * It does not work with stateless components like BUIETextEditorToolbar.
 * Since BUIETextEditorToolbar does not use state and its only prop, "editor," remains unchanged,
 * operations within it cannot trigger a re-render.
 * */
export const TextEditorToolbar = ({ editor }: TextEditorToolbarProps) => {
  const shouldRenderNewToolbar = useSplitTreatment(
    FEATURE_FLAGS.FORMS_RICH_TEXT_TOOLBAR_REFACTOR,
  );

  if (!shouldRenderNewToolbar) {
    return (
      <BubbleMenu
        className="bubble-menu"
        editor={editor}
        tippyOptions={{ duration: 100 }}
      >
        <BuieTextEditorToolbar editor={editor} />
      </BubbleMenu>
    );
  }

  return (
    <BubbleMenu editor={editor} tippyOptions={{ duration: 100 }}>
      <BlueprintTextEditorToolbar editor={editor} />
    </BubbleMenu>
  );
};
